import clsx from 'clsx';

import { AnyObject } from '@typings';
import {
  isArray,
  isBoolean,
  isNumber,
  isObject,
  isString,
  joinNonEmptyStrings,
} from '@utils';

import { Render } from '@components/Shared';

type Props = {
  isSchemaArray?: boolean;
  isTopLevel?: boolean;
  schema: any;
  params: AnyObject;
  prefix?: string;
};

export const PlatformAppManagementParamsSchema: React.FC<Props> = ({
  isSchemaArray,
  isTopLevel,
  schema,
  params,
  prefix = '',
}) => {
  const renderFormattedValue = (value: any) => {
    if (isBoolean(value)) {
      const formattedBooleanValue = value ? 'true' : 'false';

      return <span className="text-pink-800">{formattedBooleanValue}</span>;
    }

    if (value === null) {
      return <span className="text-neural-06">null</span>;
    }

    if (value === '') {
      return <span className="text-lime-800">&quot;&quot;</span>;
    }

    if (isString(value)) {
      return <span className="text-lime-800">{value}</span>;
    }

    if (isNumber(value)) {
      return <span className="text-cyan-800">{value}</span>;
    }

    return value;
  };

  const makeSchema = ([key, param]: [string, any]) => {
    const schemaKey = isSchemaArray ? '[]' : key;
    const fullKey = joinNonEmptyStrings(prefix, schemaKey);
    const metadata = params[fullKey];
    const isSchema = isObject(param) || isArray(param);

    return (
      <div key={joinNonEmptyStrings(prefix, key)}>
        <h4 className={clsx({ 'text-h6': isTopLevel })}>
          {metadata?.title ?? key}
          <Render if={isSchemaArray}> ({key})</Render>
        </h4>
        <Render if={isSchema}>
          <div className="flex flex-col gap-4 pl-4">
            <PlatformAppManagementParamsSchema
              isSchemaArray={isArray(param)}
              key={fullKey}
              prefix={fullKey}
              params={params}
              schema={param}
            />
          </div>
        </Render>
        <Render if={!isSchema}>
          <p>{renderFormattedValue(param)}</p>
        </Render>
      </div>
    );
  };

  return <>{Object.entries(schema).map(makeSchema)}</>;
};
